import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.orderLogsTab.title, 'Logs'),
  logDate: () => __(translations.orderLogsTab.logDate, 'Date'),
  user: () => __(translations.orderLogsTab.user, 'User'),
  action: () => __(translations.orderLogsTab.action, 'Action'),
};
